


















import Vue from 'vue'
import { Component, Watch, Prop } from 'vue-property-decorator'
import { SingleAssetUsage } from '@/store/modules/asset'
import { CollageClipper } from '@/components/products/malennachzahlen/util/paintingClipper'
import { PaintingByNumbersModule, PaintingInfo } from '../../../store/modules/paintingByNumbers';

@Component({
    name: 'painting-by-numbers-editor-passive'
})
export default class PaintingByNumbersEditorPassive extends Vue {
    @Prop() private step!: number
    @Prop() public usageName!: string

    public collageImageClipper = CollageClipper.getCollageClipper(false, this.imageEditorWidth, this.imageEditorHeight, this.step, this.usageName)
    public collageImageUrl = ""

    get updatePreview() {
        return PaintingByNumbersModule.updatePreview
    }

    @Watch('updatePreview')
    updatePuzzleBoxChanged() {
        this.setPreviewAsset()
    }

    get hasOverlaySlot() {
        return !!this.$slots['overlay']
    }

    get imageEditorWidth() {
        return PaintingByNumbersModule.imageEditorWidth
    }

    get imageEditorHeight() {
        return PaintingByNumbersModule.imageEditorHeight
    }

    get parts() {
        return PaintingByNumbersModule.parts
    }

    get scale() {
        return 1
    }

    setPreviewAsset() {
        let asset = PaintingByNumbersModule.activeAssets[this.usageName]
        if (asset !== undefined) {
            let usage = asset.usage[this.usageName] as SingleAssetUsage
            if (!usage) {
                usage = asset.pendingUsage[this.usageName] as SingleAssetUsage
            }
            if (usage && asset !== undefined) {
                this.collageImageUrl = asset.url
                this.collageImageClipper.initializeUsage(usage, asset.rect)
            } else {
                this.collageImageUrl = ""
            }
        } else {
            this.collageImageUrl = ""
        }
    }

    mounted() {
        this.setPreviewAsset()
    }
}
